import { Button, Dialog } from "@/components/ui";
import React from "react";
import { CaptionCoach } from "@/components";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  handleAcceptedContent: (content: { caption: string; hashtags: string[] }) => void;
  context?: string;
  contextType?: string;

  industryRoleOverride?: string;
  coachIdOverride?: string | number;
  playerIdOverride?: string | number;
}

export function CaptionCoachDialog({
  open,
  onOpenChange,
  handleAcceptedContent,
  context,
  contextType,
  industryRoleOverride,
  coachIdOverride,
  playerIdOverride,
}: Props) {
  const [blockedWords, setBlockedWords] = React.useState<string[]>([]);
  const [flaggedWords, setFlaggedWords] = React.useState<string[]>([]);
  const [prediction, setPrediction] = React.useState<string | null>(null);

  const onAccept = () => {
    if (prediction) {
      const hashtags = prediction.match(/#[\w-]+/g) || [];
      const caption = prediction.replace(/\s?#[\w-]+/g, "").trim();
      handleAcceptedContent({ caption, hashtags: hashtags });
    } else {
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange} size={"2xl"}>
      <Dialog.Content>
        <CaptionCoach
          context={context}
          contextType={contextType}
          handlePrediction={setPrediction}
          handleBlockedWords={setBlockedWords}
          handleFlaggedWords={setFlaggedWords}
          industryRoleOverride={industryRoleOverride}
          coachIdOverride={coachIdOverride}
          playerIdOverride={playerIdOverride}
        />
      </Dialog.Content>
      <Dialog.Footer>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Close
        </Button>
        {prediction && (
          <Button onClick={() => onAccept()} disabled={blockedWords.length > 0}>
            Apply Caption
          </Button>
        )}
      </Dialog.Footer>
    </Dialog>
  );
}
